export default __webpack_public_path__ + "static/media/title_en_pc.9c8fcb05.png";